var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-skeleton-row",style:({
    width: _vm.width,
    padding: _vm.padding,
    'justify-content': _vm.center
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }